/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `OPEN` - Open
* `BL` - Backlog
* `PL` - Planning
* `SC` - Scheduled
* `BOOKED` - Booked
* `CO` - Complete
* `CA` - Cancelled
 */
export type InspectionStatus = typeof InspectionStatus[keyof typeof InspectionStatus];


export const InspectionStatus = {
  OPEN: 'OPEN',
  BL: 'BL',
  PL: 'PL',
  SC: 'SC',
  BOOKED: 'BOOKED',
  CO: 'CO',
  CA: 'CA',
} as const;
